
import React from 'react';
import { hasPermission } from '@/utils/roleManagement';
import { UserRole } from '@/types/userRole';

interface RoleBasedAccessProps {
  permission: string;
  userRole?: UserRole;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Component that conditionally renders content based on user permissions
 */
const RoleBasedAccess: React.FC<RoleBasedAccessProps> = ({
  permission,
  userRole,
  children,
  fallback = null
}) => {
  // Check if the user has the required permission
  const hasAccess = hasPermission(userRole, permission);

  // If the user has access, render the children, otherwise render the fallback
  return hasAccess ? <>{children}</> : <>{fallback}</>;
};

export default RoleBasedAccess;
